import { IonContent, IonPage } from "@ionic/react";
import { useState } from "react";
import { withRouter } from "react-router";
import Header from "src/components/Header";
import { Typography } from "@material-ui/core";
import { AsignacionProps } from "src/utils";
import TablaDetalleAsignacion from "src/components/asignacion/tabla/TablaDetalleAsignacion";
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import DiaLibre from "src/components/diaLibre/DiaLibre";
// import Reemplazo from "src/components/Reemplazo/Reemplazo"; // Reemplazado por módulo "Reemplazos (nuevo)" (reemplazosV2)
// import GestionMarcacion from "src/components/GestionMarcacion/GestionMarcacion"; // Acordeón oculto: reemplazado por módulo "Gestión Marcación (nuevo)"
// import CierreDiario from "./CierreDiario"; // Acordeón oculto del módulo Gestiones

const Accordion = withStyles({
  root: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    width: '100%',
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
}))(MuiAccordionDetails);


const Asignacion: React.FC<AsignacionProps> = (props: AsignacionProps) => {

  const [expanded, setExpanded] = useState('');
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };



  return (
    <IonPage>
      <Header titulo="Gestiones " />
      <IonContent id="gestiones">
        <div className="container">
          <div className="d-flex mt-3 flex-column align-items-center">

            <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
              <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                <Typography>Asignacion</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TablaDetalleAsignacion />
              </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
              <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                <Typography>Dia Libre</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <DiaLibre />
              </AccordionDetails>
            </Accordion>
                     {/* Acordeón "Reemplazo" oculto: reemplazado por el módulo "Reemplazos (nuevo)" (reemplazosV2)
                     <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                       <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                         <Typography>Reemplazo</Typography>
                       </AccordionSummary>
                       <AccordionDetails>
                           <Reemplazo/>
                       </AccordionDetails>
                     </Accordion>
                     */}
                     {/* Acordeón "Gestion Marcacion" oculto: reemplazado por el módulo "Gestión Marcación (nuevo)" (gestionMarcacionV2)
                     <Accordion square expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                       <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
                         <Typography>Gestion Marcacion</Typography>
                       </AccordionSummary>
                       <AccordionDetails>
                           <GestionMarcacion/>
                       </AccordionDetails>
                     </Accordion>
                     */}
                      {/* Acordeón "Cierre Diario" oculto del módulo Gestiones
                      <Accordion square expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
              <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
                <Typography>Cierre Diario</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CierreDiario retrieveData={expanded === 'panel5'} />
              </AccordionDetails>
            </Accordion>
                      */}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(Asignacion);